import React, {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import { tagFetcher } from "../api/requests";

const TagsContext = createContext();

const TagsContextProvider = ({ children }) => {
  const [tags, setTags] = useState({});
  const [topTags, setTopTags] = useState({});

  const updateTags = useCallback((newData) => {
    setTags(newData);
  }, []);

  const updateTopTags = useCallback((newData) => {
    setTopTags(newData);
  }, []);

  useEffect(() => {
    const getTags = async () => {
      try {
        setTags(await tagFetcher.getConfirmedTags());
      } catch (err) {
        console.error(err);
      }
    };

    const getTopTags = async () => {
      try {
        setTopTags(await tagFetcher.getConfirmedTopTags());
      } catch (err) {
        console.error(err);
      }
    };

    getTags();
    getTopTags();
  }, []);

  const contextValue = useMemo(
    () => ({
      tags,
      updateTags,
      topTags,
    }),
    [tags, updateTags, topTags]
  );

  return (
    <TagsContext.Provider value={contextValue}>{children}</TagsContext.Provider>
  );
};

export { TagsContext, TagsContextProvider };
